import { MainPage } from "./feature";

function App() {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;
